import { Box, Column } from '@tempmee/react';

/**
 * Loading placeholder for one dashboard count tile. The DS `OfficeDashboardTile`
 * has no loading state of its own, so `ShiftsSection` holds each tile's slot
 * with this until the counts land.
 *
 * Mirrors the tile's surface and rows (number, title, description, accent bar)
 * so the row keeps its shape. Static by decision: the DS stylesheet has no
 * animation class, and a shimmer would need a stylesheet of our own. Carries
 * none of the tiles' `data-cy` handles, so a test or E2E selector waiting on a
 * tile never matches a placeholder.
 */
export const DashboardTileSkeleton = () => (
  <Column
    className="flex-1 min-w-[192px] overflow-hidden rounded-lg bg-background-paper shadow-elevation-1"
    aria-hidden
    data-cy="dashboard-tile-skeleton"
  >
    <Column className="px-3 pt-3 pb-2">
      <Box className="h-14 w-16 rounded bg-neutral-100" />
      <Box className="h-7 w-40 rounded bg-neutral-100" />
      <Box className="h-4 w-full rounded bg-neutral-100" />
    </Column>
    <Box className="h-1 w-full bg-neutral-200" />
  </Column>
);
